<div class="component-select">
  <span class="component-select-title">{{ title }}</span>
  <ng-select
    class="component-select-control"
    (change)="changeValue.emit($event)"
    [clearOnBackspace]="false"
    [placeholder]="placeHolder"
    [clearable]="clearable"
    [(ngModel)]="selectedValue"
    >
    @for (item of finalOptions; track item) {
      <ng-option [value]="item.value">
        {{ translate ? (item.label | cxTranslate) : item.label }}
      </ng-option>
    }
  </ng-select>
</div>
